import { render, staticRenderFns } from "./the-plan-design-your-characters.vue?vue&type=template&id=4ffa147a&"
import script from "./the-plan-design-your-characters.vue?vue&type=script&lang=js&"
export * from "./the-plan-design-your-characters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports